import Amplify, { API } from 'aws-amplify';

import config from '../amplify/config.js';

export default () => {
  Amplify.configure(config);
  return API.get('user', 'create-demo-user');
};
